export default "__VITE_ASSET__BYA0jX5___"